import React, { Component } from "react";
import * as s from "./SearchHeader.module.scss";
import { P } from "src/views/shared/components";
import { SearchStore } from "src/stores";
import { inject, observer } from "mobx-react";
import { tx } from "src/libs/i18n";
import { Icons } from "src/libs/assets";

export interface SearchHeaderProps {
  searchStore?: SearchStore;
}

@inject("searchStore")
@observer
export class SearchHeader extends Component<SearchHeaderProps> {
  renderTitle = () => {
    const { searchStore } = this.props;
    const { numberOfDocumentResults } = searchStore;
    let titlePrefix =
      numberOfDocumentResults > 0 ? numberOfDocumentResults : tx("search.no");
    let titleSuffix =
      numberOfDocumentResults > 1
        ? tx("search.documents")
        : tx("search.document");
    return <h1 className={s.title}>{titlePrefix + " " + titleSuffix}</h1>;
  };

  render() {
    const { searchStore } = this.props;
    const { isSearching } = searchStore;

    return (
      <div className={s.searchHeader}>
        {isSearching ? (
          <div className={s.spinnerWrapper}>
            <img className={s.spinner} src={Icons.spinner} />
          </div>
        ) : (
          <>
            <P medium className={s.preTitle}>
              {tx("search.weFound")}
            </P>
            {this.renderTitle()}
          </>
        )}
      </div>
    );
  }
}
